import React from "react";
import { Col, Row } from "antd";
import { EventRegisteredTeams } from "../../../../common/righbar/Righbar";

const RegisterTeams = ({ event }) => {
  return (
    <Row className="rowPadding" justify={"center"}>
      <Col xs={{ span: 24 }} className="scroll">
        <EventRegisteredTeams teams={event?.registerteams} />
      </Col>
    </Row>
  );
};

export default RegisterTeams;
